import type { SettingsResponse } from "../../shared/types";
import { DEFAULT_IDLE_MINUTES } from "../../shared/tags";

/** Who hears about replies, messages and answers: the workspace's reply list. */
export function teamOf(data: SettingsResponse): string[] {
  return (data.automations.reply_forward_to ?? "")
    .split(",")
    .map((x) => x.trim())
    .filter(Boolean);
}

export const IDLE_MIN = 1;
export const IDLE_MAX = 1440;

/** What the automations save sends: the minutes and the team as one list. */
export const automationsBody = (minutes: number, team: string[]) => ({ idle_minutes: minutes, reply_forward_to: team.join(", ") });

/** The minutes as typed, held to 1 to 1440; anything unreadable is the default. */
export function idleMinutesFrom(text: string): number {
  const n = Math.round(Number(text));
  if (!Number.isFinite(n) || n <= 0) return DEFAULT_IDLE_MINUTES;
  return Math.min(IDLE_MAX, Math.max(IDLE_MIN, n));
}
